import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    width: 200px;
    border-radius: 8px;
    border: 1px solid #005AA9;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1em;
    box-shadow: 0px 10px 20px 0px #ADAEAE40;
    cursor: pointer;
    transition: 0.3s;
    &&:hover {
        background-color: #005AA9;
        box-shadow: none;
    }
    &&:hover > div:first-child {
        color: #DADCE0;
    }
    &&:hover > div:last-child {
        color: #FFFFFF;
    }
`;

const TitleText = styled.div`
    font-family: Work Sans;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-transform: uppercase;
    color: #5F6368;
`;

const ValueText = styled.div`
    font-family: Space Mono;
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    letter-spacing: 0em;
    color: #005AA9;
`;

const EmailMetricCell = ({ metricName, value }) => <Wrapper>
  <TitleText>{metricName}</TitleText>
  <ValueText>{value}</ValueText>
</Wrapper>;

export default EmailMetricCell;
